// Shopify Universal Console Suppressor
(function(){
  // Override all console methods
  ['log','warn','error','info','debug','table','dir'].forEach(m=>{
    if(console[m]) console[m]=function(){};
  });

  // Function to clear console safely
  function clearConsole(){ try{ console.clear(); } catch(e){} }

  // Clear immediately, every 1s and every 4s for aggressive clearing
  clearConsole();
  setInterval(clearConsole, 1000);
  setInterval(clearConsole, 4000);

  // Suppress JS errors and unhandled promise rejections
  window.onerror = window.onunhandledrejection = function(){ return true; };

  // Patch addEventListener globally to prevent null errors
  const origAddEvent = EventTarget.prototype.addEventListener;
  EventTarget.prototype.addEventListener = function(type, listener, options){
    try { return origAddEvent.call(this,type,listener,options); } catch(e){}
  };

  // Patch querySelector / querySelectorAll to prevent null errors
  const origQuery = document.querySelector;
  const origQueryAll = document.querySelectorAll;
  document.querySelector = function(sel){ try { return origQuery.call(document, sel); } catch(e){ return null; } };
  document.querySelectorAll = function(sel){ try { return origQueryAll.call(document, sel); } catch(e){ return []; } };

  // Observe DOM changes to clear dynamically added errors
  const observer = new MutationObserver(clearConsole);
  observer.observe(document, { childList: true, subtree: true });

})();
